import { useTipFeeBps, useVenuesDataStore } from "@/store/useVenuesDataStore";
import { tipFeeGrosze } from "@/helpers/cartPricing";
import PaymentMethodPicker from "@/components/PaymentMethodPicker/PaymentMethodPicker";
import styles from "./ConfirmAndPay.module.scss";
import IconButton from "@/components/IconButton/IconButton";
import useOnClickFunctions from "../../helpers/onClickFunctions";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function ConfirmAndPay() {
  const { selectedAmount, remainingAmount, tipAmount, setVenuesData } =
    useVenuesDataStore();
  const extraTipAmount = (selectedAmount * 100 - remainingAmount) / 100;
  const tipFeeBps = useTipFeeBps();
  // This drawer keeps its money in major units; the fee is a grosze rule.
  const tipFee = tipFeeGrosze(Math.round(tipAmount * 100), tipFeeBps);
  const { handleNavigate } = useOnClickFunctions();
  const { restaurantId, tableId } = useParams();
  const [selectedMethod, setSelectedMethod] = useState<string | null>(null);
  const { t } = useTranslation();

  const [blikCodeValue, setBlikCodeValue] = useState("");

  // Publish the code on every keystroke. This used to depend only on the
  // selected method, so the typed value never reached the store — and since
  // handlePay rejects a code that is not six digits, Blik could never succeed.
  useEffect(() => {
    setVenuesData({
      blikCode: selectedMethod === "Blik" ? blikCodeValue : "",
    });
  }, [selectedMethod, blikCodeValue, setVenuesData]);

  useEffect(() => {
    setVenuesData({ paymentMethod: selectedMethod });
  }, [selectedMethod]);

  return (
    <div className={styles.confirmAndPayContent}>
      <div className={styles.confirmAndPaySummaryContainer}>
        <div className={styles.confirmAndPaySummaryDetailsContainer}>
          <p className={`title-large ${styles.summaryLabel}`}>
            {t("confirmAndPay.subtotal")}
          </p>
          <p
            className={`title-large ${styles.summaryValue}`}
          >{`${(selectedAmount + tipAmount).toFixed(2)} zł`}</p>
        </div>
        {extraTipAmount > 0 ? (
          <div className={styles.confirmAndPaySummaryDetailsContainer}>
            <p className={`title-large ${styles.summaryLabel}`}>
              {t("confirmAndPay.tip")}
            </p>
            <p
              className={`title-large ${styles.summaryValue}`}
            >{`${extraTipAmount.toFixed(2)} zł`}</p>
          </div>
        ) : tipAmount > 0 ? (
          <div className={styles.confirmAndPaySummaryDetailsContainer}>
            <p className={`title-large ${styles.summaryLabel}`}>
              {t("confirmAndPay.tip")}
            </p>
            <p
              className={`title-large ${styles.summaryValue}`}
            >{`${tipAmount.toFixed(2)} zł`}</p>
          </div>
        ) : null}
        {/* The venue's fee on the tip, at the rate its branding publishes.
            Was a hardcoded 0.5% of the bill, which the backend never charged
            the guest: the bill's own fee comes out of the venue's payout. */}
        {tipFee > 0 ? (
          <div className={styles.confirmAndPaySummaryDetailsContainer}>
            <div className={styles.checkoutFeeTextAndIcon}>
              <p className={`title-large ${styles.summaryLabel}`}>
                {t("confirmAndPay.checkoutFee")}
              </p>

              <IconButton
                iconName="las la-info-circle icon-big"
                color="primary"
                variant="text"
                onClick={() => {
                  handleNavigate(
                    `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/checkout-fee`,
                  );
                }}
              />
            </div>
            <p className={`title-large ${styles.summaryValue}`}>
              {`${(tipFee / 100).toFixed(2)} zł`}
            </p>
          </div>
        ) : null}
      </div>
      <p className={`title-large ${styles.payWithTitle}`}>
        {t("confirmAndPay.payWithTitle")}
      </p>
      <PaymentMethodPicker
        selected={selectedMethod}
        onSelect={setSelectedMethod}
        blikCode={blikCodeValue}
        setBlikCode={setBlikCodeValue}
      />
    </div>
  );
}

export default ConfirmAndPay;
